document.addEventListener('DOMContentLoaded', function () {
    const toc = document.getElementById('show-desk-sticky-toc-revamp');
    const mobileFixed = document.querySelector('.mobile-fixed');
    const header = document.querySelector('.site-header');

    if (toc) {
        const tocLinks = toc.querySelectorAll('.desk-sidebar-links');
        const newLocation = document.querySelector('.c-px-percent-5.toc-div-revamp');
        if (newLocation) {
            newLocation.querySelectorAll('p').forEach(p => p.remove()); // Remove existing p tags

            const accordionContent = document.createElement('div');
            accordionContent.classList.add('accordion-content');

            tocLinks.forEach(function (link) {
                const hasAnchor = link.querySelector('a');
                if (hasAnchor) {
                    const clonedLink = link.cloneNode(true);
                    accordionContent.appendChild(clonedLink);
                }
            });
            newLocation.appendChild(accordionContent);
        }

    const sections = Array.from(tocLinks).map(link => {
        const href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
            const sectionId = href.substring(1);
            return document.getElementById(sectionId);
        }
        return null;
    }).filter(Boolean);
    }

    if(document.querySelector('.toc-div-revamp')){
        document.querySelector('body').classList.add('has-toc');
    }
    
    document.addEventListener("scroll", (event) => {
        if(mobileFixed){
            var bodyRect = document.body.getBoundingClientRect();
        if(window.innerWidth < 1269){    
            if(document.querySelector('#show-mob-toc')){
                const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                // Debug logs
                console.log('Scroll position:', scrollPosition);
                console.log('Mobile fixed element exists:', !!mobileFixed);
                console.log('Current classes:', mobileFixed.classList.toString());

                if (scrollPosition > 900){
                    mobileFixed.classList.add('show');
                    header.classList.add('no-shadow');
                } else {
                    mobileFixed.classList.remove('show');
                    header.classList.remove('no-shadow');
                }
            }
        }
    }

    let linksMobile = document.querySelectorAll('.toc-div-revamp .desk-sidebar-links a'); 
    linksMobile.forEach(function(childLinksMobile){
        childLinksMobile.addEventListener('click', function(event) {
            // Prevent the default behavior of the anchor tag
            event.preventDefault();
            // Remove class-bolder from all links
            document.querySelectorAll('a.class-bolder').forEach(obj => obj.classList.remove('class-bolder'));
            // Add class-bolder to the clicked link
            childLinksMobile.classList.add('class-bolder');
            // Scroll to the target element
            let href = childLinksMobile.getAttribute('href');
            let targetId = href ? href.substring(href.indexOf('#') + 1) : null;
            let targetElement = document.getElementById(targetId);
            if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth' }); // Use scrollIntoView for smoother scrolling
                    window.location.hash = targetId;
                }
            });
        });
        
    });

    let linksDesktop = document.querySelectorAll('.toc-div-revamp .desk-sidebar-links a');  
    if(linksDesktop.length > 0){
        linksDesktop.forEach(function(child){
        child.addEventListener('click', (event) => {
            var mainHeaderWrapper = document.querySelector('.main-header-wrapper');
            if(document.querySelectorAll('a.class-bolder')){
                document.querySelectorAll("a.class-bolder").forEach(obj=>obj.classList.remove("class-bolder"));        
            }        
            event.currentTarget.classList.add('class-bolder');      
            if(window.innerWidth < 1269){
            document.querySelector('.revamp .cb-accordion-header').click();
            }
            if(window.innerWidth < 1269){
                event.currentTarget.classList.add('click-link');   
                event.currentTarget.classList.add('class-bolder');     
            }
            var childDataHref = event.currentTarget.getAttribute('href');
            var childDataDiv = document.querySelector(childDataHref);
            let scrollOffset = 80; 
            if (window.innerWidth < 992) {
                scrollOffset = 120;
            }
            if(window.innerWidth < 1269){
                setTimeout(function(){
                    document.querySelectorAll("a.class-bolder").forEach(obj => obj.classList.remove("class-bolder"));
                    if(document.querySelector('a.click-link')){
                        document.querySelector('a.click-link').classList.add('class-bolder');  
                        document.querySelector('a.click-link').classList.remove('click-link');
                    }
                },1000);
            } 
        });

        }); 
        var currUrl = location.pathname;
        if(currUrl.includes('#')){
        var currUrlSplit = document.querySelector('a[href="'+location.pathname+'"]').getAttribute('data-href');
        var currUrlId = document.querySelector(currUrlSplit); 
        }
    }


    function isElementInViewportTop(el) {
        if (!el) return false; 
        const rect = el.getBoundingClientRect();
        return (rect.top <= window.innerHeight && rect.top >= 0); // Element is visible from the top
    }

    function addBolderClassToAnchor() {
        let closestElement = null;
        let minDistance = Infinity;
        let foundActive = false;
        let userClicked = false;
        
        let accordionAnchorTags = document.querySelectorAll('.revamp cb-accordion .desk-sidebar-links a');// Check for elements inside the accordion
        accordionAnchorTags.forEach(function (anchorTag) {
        let targetId = anchorTag.hash.substring(1);
        let targetElement = document.getElementById(targetId);
        anchorTag.addEventListener('click', function () {
            userClicked = false;
            setTimeout(() => userClicked = true, 2000); // Reset after 1s to re-enable auto-detection
        });
            if (targetElement && isElementInViewportTop(targetElement) && !userClicked) {
                document.querySelectorAll('cb-accordion a.class-bolder').forEach(obj => obj.classList.remove("class-bolder"));
                anchorTag.classList.add('class-bolder');
            }
    });


        // Check for elements inside the sticky toc div
    let tocAnchorTags = document.querySelectorAll('#show-desk-sticky-toc-revamp .desk-sidebar-links a');
    tocAnchorTags.forEach(function (anchorTag) {
        let targetId = anchorTag.hash.substring(1);
        let targetElement = document.getElementById(targetId);
        if (targetElement) {
            let rect = targetElement.getBoundingClientRect();

            // Check if the element is within the viewport
                if (rect.top >= 0 && rect.top < window.innerHeight) {
                let distanceFromTop = Math.abs(rect.top);

                // Update the closest element
                if (distanceFromTop < minDistance) {
                    closestElement = anchorTag;
                    minDistance = distanceFromTop;
                }
            }
        }
        });
        // If a new closest element is found, update the active link
        if (closestElement) {
            tocAnchorTags.forEach(obj => obj.classList.remove("class-bolder")); // Remove only if new closest is found
            closestElement.classList.add("class-bolder");
            foundActive = true;
        }
        // If no active link is found, do nothing (retain the last active one)
        if (!foundActive) return;
    }
    window.addEventListener('scroll', addBolderClassToAnchor);
    addBolderClassToAnchor();

    // Function to handle the container class based on window width
    function handleContainerClass() {
        const revampElement = document.querySelector('.revamp');
        if (revampElement) {
            if (window.innerWidth >= 1350) {
                revampElement.classList.add('container');
            } else {
                revampElement.classList.remove('container');
            }
        }
    }

    handleContainerClass();

    // Resize event listener
    window.addEventListener('resize', handleContainerClass);

    // Breadcrumbs 
    var breadcrumbHtml = document.getElementById("outer-breadcrumb").innerHTML;
    var targetDiv = document.getElementById("breadcrumbs-revamp");
    if (targetDiv) {
        targetDiv.innerHTML = breadcrumbHtml;
        targetDiv.style.display = "block";
    }
});

document.addEventListener("DOMContentLoaded", function () {
});

//   document.addEventListener("DOMContentLoaded", function () {
//     var breadcrumbHtml = document.getElementById("outer-breadcrumb").innerHTML;
//     var targetDiv = document.getElementById("breadcrumbs-revamp-2");
//     if (targetDiv) {
//       targetDiv.innerHTML = breadcrumbHtml;
//       targetDiv.style.display = "block";
//     }
//   });